import { render } from "./AboutTimeline.vue?vue&type=template&id=4df02780&scoped=true"
import script from "./AboutTimeline.vue?vue&type=script&lang=js"
export * from "./AboutTimeline.vue?vue&type=script&lang=js"

import "./AboutTimeline.vue?vue&type=style&index=0&id=4df02780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df02780"]])

export default __exports__